import LegalLayout from "@/components/legal/legal-layout"
import content from "@/content/legal/cerrar-cuenta.md?raw"

export default function CloseAccount() {
  return <LegalLayout title="Cerrar tu cuenta" content={content} />
}
